export default class ApiError extends Error {
    // Private, so no serializer (Sentry's included) walks into the backend's payload.
    #detail;
    #data;

    constructor(status, title, type, detail, data, silent = false) {
        super(`Request failed with status ${status}`);
        this.name = 'ApiError';
        this.status = status;
        this.title = title;
        this.type = type;
        this.#detail = detail;
        this.#data = data;
        this.silent = silent;
    }

    get detail() {
        return this.#detail;
    }

    get data() {
        return this.#data;
    }

    static fromResponse({status, title, type, detail, data}, silent) {
        return new ApiError(status, title, type, detail, data, silent);
    }

    toString() {
        return `[ERROR - ${this.type}]: ${this.#detail}`;
    }
}
